<template>
  <div>
  <nav id="main-nav">
    <section class="primary-nav">
      <middle />
    </section>
  </nav>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Middle from '@/components/navigation/Middle'

export default {
  name: 'Navigation',
  components: {
    middle: Middle
  },
  computed: {
    ...mapGetters('window', [
      'isMobile'
    ])
  }
}
</script>
